import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './modules/fptai/filters/filters'
// plugin
import i18n from './plugins/i18n'
import './plugins/vuetify'
import './plugins/vue-cookies'
import './plugins/axios'
import './plugins/moment'
import './plugins/googlemap'
import './plugins/vue-notification'
// app included
import './utils/utils'
import './utils/const'
import './store/actionTypes'
import './event-bus'
import '@/services/app.service'

Vue.config.productionTip = false

window.vueapp = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
